export default "__VITE_ASSET__YCrJf2H$__"